import { request } from "../../backend";
import { AgreementMetadata } from "../../models/AgreementMetadata";

export async function fetchAgreementMetadata(agreementKey: string, open?: boolean): Promise<AgreementMetadata> {
  if (typeof open !== 'boolean') {
    open = document.location.hostname.startsWith('signera.') || document.location.hostname.startsWith('xn--frslag-wxa.') || document.location.hostname.startsWith('192.');
  }
  const { metadata } = await request(`/agreement/${agreementKey}/meta`, 'get', null, { open });
  return new AgreementMetadata(metadata);
}